import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, OnChanges } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CourseService } from 'src/app/services/course.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-course-work-autograde',
  templateUrl: './course-work-autograde.component.html',
  styleUrls: ['./course-work-autograde.component.scss']
})
export class CourseWorkAutogradeComponent implements OnInit, OnChanges {

  @Input() loader: boolean;
  @Input() courseworks: any;
  @Input() courseId: string = '';
  @Output() onAutogradingStart: EventEmitter<any> = new EventEmitter<any>()
  courseWorkId: string = '';
  scheduleId: string = '';
  autogradingStatus: number = 0;
  autogradingStatusMsg: string = '';
  isAutogradingAllowed: boolean = false;
  statusModalRef: NgbModalRef = null;
  isLoading: boolean = false;
  @ViewChild('statusModal', { static: false }) statusModal!: ElementRef;

  constructor(private modalService: NgbModal, private notificationService: NotificationService, private courseService: CourseService) { }

  /**
   * To initialize component data.
   */
  ngOnInit() {    
  }

  /**
   * To detect input data changes.
   * @param {SimpleChanges} changes - To get input data
   */
  ngOnChanges(changes: SimpleChanges) {
    if ('loader' in changes && changes['loader'].firstChange == false) {
      if ('courseworks' in changes && changes['courseworks'].firstChange == false) {
        this.courseWorkId = this.courseworks._id;
        this.scheduleId = this.courseworks.schedule_id;
        this.autogradingStatus = this.courseworks.autograde_pipeline_status;
        this.isAutogradingAllowed = this.courseworks.is_autograding_allowed;
        if(this.autogradingStatus === 1) {
          this.autogradingStatusMsg = 'Autograding in progress.';
        }
        else if (this.autogradingStatus === -1) {
          this.autogradingStatusMsg = 'The autograding process encountered an error. Please reach out to your administrator for help.';
        }
        else if (this.autogradingStatus === 2) {
          this.autogradingStatusMsg = 'Autograding completed.';
        }
      }      
    }
  }

  /**
   * To run auto grading pipeline job.
   */
  onRunAutograding() {
    this.isLoading = true;
    this.onAutogradingStart.emit({ isLoading: this.isLoading });
    this.courseService.autogradeCoursework({ course_id: this.courseId, coursework_id: this.courseWorkId, coursework_instance_id: this.scheduleId}).subscribe(response => {
      this.isLoading = false;
      this.onAutogradingStart.emit({ isLoading: this.isLoading });
      if(Object.keys(response.data).length > 0) {        
        if(response.data.autograde_status == 1) {
          this.autogradingStatus = response.data.autograde_status;
          this.autogradingStatusMsg = response.data.autograde_status_msg;
          this.isAutogradingAllowed = false;
          this.openStatusModel();
        }
        else {
          this.notificationService.showNotification('error', 'Autograding process failed.');
        }
      }
      else {
        this.notificationService.showNotification('error', 'Something went wrong. Please try again later.');
      }
    },(error) => {
      this.isLoading = false;
      this.onAutogradingStart.emit({ isLoading: this.isLoading });
      this.notificationService.showNotification('error', error.message);
    });
  }

  /**
   * To open autograding status popup.
   */
  openStatusModel() {
    this.statusModalRef = this.modalService.open(this.statusModal);
  }

  /**
   * To close autograding status popup.
   */
  closeStatusModel() {
    this.statusModalRef.close();
  }
}
